/**
 * Generates initial values for a form based on provided data.
 * Excludes keys with empty string ('') or null values.
 *
 * @param {Object} data - The source data to generate initial values from.
 * @param {Object} defaultValues - The default values to use for the form.
 * @returns {Object} An object with initial values for the form.
 */
const getInitialValues = (props) => {
  const { data, defaultValues } = props;

  // Combine keys from both data and defaultValues
  const combinedKeys = new Set([...Object.keys(defaultValues), ...Object.keys(data)]);

  // Construct the new object with values from data or defaultValues
  return Array.from(combinedKeys).reduce((acc, key) => {
    // Use data's value if it exists and is not an empty string or null
    if (data[key] !== '' && data[key] !== null && data[key] !== undefined) {
      acc[key] = data[key];
    } else {
      // Fallback to defaultValues
      acc[key] = defaultValues[key];
    }
    return acc;
  }, {});
};

export default getInitialValues;
